import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { store } from "../components/Store";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Keyboard } from 'swiper';
import PodemosAyudar from "../PodemosAyudar/";
import useObtenerSubsecciones from "../js/translations/useObtenerSubsecciones";
import { Img } from "../components/shared/img";

/**
 * Este componente no recibe props. Este renderiza la pantalla de "¿qué es bibliotecas?". Para esto hace uso del componente PodemosAyudar y Img. 
 * @returns {JSXElement} QueEsBibliotecas
 */

const QueEsBibliotecas = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { isReady, textosSubSecciones: textosBibliotecas } = useObtenerSubsecciones('que_es_biblioteca');

  const bibliotecas = [
    {
      paquete: [
        {
          carpeta: 'editoriales2',
          img: 'editorial-circulo-abierto.png',
        },
        {
          carpeta: 'instituciones',
          img: 'Breteau.png',
        },
        {
          carpeta: 'instituciones',
          img: 'Pereira.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'manizales.jpg',
        },
        {
          carpeta: 'instituciones',
          img: 'Harp.png',
        },
        {
          carpeta: 'instituciones',
          img: 'Globant.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'mineducacion.jpg',
        },
        {
          carpeta: 'bibliotecas',
          img: 'comfamiliarHuila.png',
        },
      ]
    },
    {
      paquete: [
        {
          carpeta: 'bibliotecas',
          img: 'comfama.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'compensar.jpg',
        },
        {
          carpeta: 'instituciones',
          img: 'Javeriana.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'externado.jpg',
        },
        {
          carpeta: 'bibliotecas',
          img: 'casaliteraturaperuana.jpg',
        },
        {
          carpeta: 'bibliotecas',
          img: 'denver.jpg',
        },
        {
          carpeta: 'bibliotecas',
          img: 'austin.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'Banrep.png',
        },
      ]
    },
    {
      paquete: [
        {
          carpeta: 'bibliotecas',
          img: 'BiblioNal.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'Bibliored.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'Boston.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'cajacopi.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'whittier.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'ComfenalcoAnt.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'ComfenalcoAtl.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'comfenalcoQuin.png',
        },
      ]
    },
    {
      paquete: [
        {
          carpeta: 'bibliotecas',
          img: 'ECarranza.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'Fundalectura.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'Inglewood.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'LosAngeles.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'pflugerville.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'piloto.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'prince.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'RedMedellin.png',
        },
      ]
    },
    {
      paquete: [
        {
          carpeta: 'bibliotecas',
          img: 'southH.png',
        },
        {
          carpeta: 'bibliotecas',
          img: 'Vallecito.png',
        },
      ]
    },

  ]

  /**
   * Esta función crea un arreglo con varios SwiperSlide. Cada uno de estos contiene un comentario
   * @returns {Array<HTMLElement>} arreglo de SwiperSlide
   */
  const crearSlide = () => {
    let items = [];
    const comentarios = textosBibliotecas?.comentarios;

    Object.keys(comentarios).map((item, index) => {
      if (comentarios[item].comentario !== 'null') {
        items.push(
          <SwiperSlide
            className={`swiper-slide focusable-secondary`}
            key={`slide-${index}`}
            modules={[Autoplay, Keyboard]}
          >
            <div tabIndex={0} className={"focusable-secondary que-es-mensaje-experiencia py-4 mb-5 mt-3 mx-auto"}>
              <p className="d-block col-11 mx-auto text-center">
                {comentarios[item].comentario}
              </p>
            </div>
            <p tabIndex={0} className="focusable-secondary onbackground-primary--color col-lg-10 mx-auto text-center"><span className="font-weight-bold">{comentarios[item].nombre} </span> {comentarios[item].cargo !== 'null' && comentarios[item].cargo} </p>
            <p tabIndex={0} className="focusable-secondary onbackground-primary--color col-lg-10 mx-auto text-center font-weight-bold"> {comentarios[item].lugar}</p>
          </SwiperSlide>
        )
      }
    });
    return items;
  }

  /**
   * Esta función crea los enlaces de las bibliotecas
   * @param {object} slide 
   * @returns {Array<HTMLElement>} arreglo de imagenes 
   */
  const crearBibliotecas = (slide) => {
    let items = [];
    for (let i = 0; i < slide.paquete.length; i++) {
      const nombreBiblioteca = slide?.paquete?.[i]?.img?.replace('.png', '').replace('.jpg','');
      items.push(
        <div className="col-4 col-lg-3 p-1 p-lg-2 focusable-by-children-secondary" key={`biblioteca-${i}`}>
          <Link to='' aria-label={`biblioteca ${nombreBiblioteca}`}>
            <div className="cover">
              <Img role={"presentation"} src={`/img/${slide.paquete[i].carpeta}/${slide.paquete[i].img}`} alt={`biblioteca-${i}`} className="img-fluid"/>
            </div>
          </Link>
        </div>
      )
    }
    return items;
  }

  /**
   * Esta función crea un SwiperSlide con un conjunto de Bibliotecas
   * @returns {Array<HTMLElement>} arreglo de un conjunto de Bibliotecas 
   */
  const crearSlideBibliotecas = () => {
    let items = [];
    for (let i = 0; i < bibliotecas.length; i++) {
      items.push(
        <SwiperSlide key={`slideBiblioteca-${i}`} modules={[Autoplay, Keyboard]} >
          <div className="row mx-0">
            {crearBibliotecas(bibliotecas[i])}
          </div>

        </SwiperSlide>
      )
    }
    return items;
  }

  return (
    <>
      {
        isReady &&
        <>
          <div className="container-fluid px-0 fuente-semibold margin-top-header">
            <div className="plan-biblioteca-button">
              <p className="">{state.idioma === 'es' && `${textosBibliotecas?.miga_de_pan?.que_es || '¿Qué es?'} |`} <strong> {textosBibliotecas?.miga_de_pan?.bibliotecas || 'Plan bibliotecas'}</strong></p>
            </div>

            <div className="second-title title-que-es primary--bg">
              <div className="container d-flex align-items-center h-100">
                <div className="col-lg-6">
                  <h1 className="text-title onprimary--color">{textosBibliotecas?.titulo?.texto || 'Bibliotecas'}</h1>
                </div>
              </div>
            </div>

            <div className="container pb-3 que-es-bibliotecas ">
              <div className="col-lg-10 mx-auto pt-5 pt-lg-4">
                <p tabIndex={0} className="focusable-secondary important-information titulo-uno mt-0 mt-lg-4 font-weight-bold">
                  {textosBibliotecas?.intro?.titulo || 'La mejor opción para tus recursos digitales'}
                </p>

                <div className="row mx-0">
                  <div className="col-lg-6 px-0 pt-lg-3">
                    <img className="py-3 px-1 iconoOfrece" alt="icono MakeMake ofrece" src="./img/bibliotecas-que-es/icono_2d_digital.png" />
                    <p className="onbackground-primary--color">{textosBibliotecas?.intro?.descripcion_uno || 'intro_uno'} <strong> {textosBibliotecas?.intro?.descripcion_dos || 'intro_dos'}</strong></p>
                    <p className="onbackground-primary--color pt-4 pb-5">{textosBibliotecas?.intro?.descripcion_tres || 'intro_tres'}</p>
                  </div>

                  <figure className="col-lg-6 pt-lg-3 d-flex align-items-center">
                    <img src="./img/bibliotecas-que-es/ilustracion_computador.png" alt="ilustración de un computador" className="img-fluid" />
                  </figure>
                </div>

              </div>
            </div>

            <div className="seccion-rosada pt-lg-4 pb-3 pb-lg-5">
              <div className="container px-0">
                <div className="col-lg-10 mx-auto">
                  <p tabIndex={0} className="focusable-secondary important-information font-weight-bold py-4">
                    {textosBibliotecas?.acompanamiento?.titulo || 'Acompañamiento y capacitación permanente'}
                  </p>

                  <ul className="row mx-0 px-0">
                    <li tabIndex={0} className="focusable-secondary col-lg-6 pt-4 pt-lg-0 py-lg-4 mb-4">
                      <img role={"presentation"} alt="imagen plan de acompanamiento" src="img/bibliotecas-que-es/plan_acompanamiento.png" />
                      <p className="mb-0 py-3" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.acompanamiento?.plan }}></p>

                    </li>
                    <li tabIndex={0} className="focusable-secondary col-lg-6 pr-lg-5 py-lg-4  mb-lg-4">
                      <img role={"presentation"} alt="imagen cursos online" src="img/bibliotecas-que-es/cursos_online.png" />
                      <p className="mb-0 py-3" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.acompanamiento?.curso }}></p>
                    </li>

                    <li tabIndex={0} className="focusable-secondary col-lg-6 pb-lg-4 mb-lg-4">
                      <img role={"presentation"} alt="imagen marketing" src="img/bibliotecas-que-es/marketing.png" />
                      <p className="mb-0 py-3 que-es-parrafo-menor" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.acompanamiento?.kit }}></p>
                    </li>

                    <li tabIndex={0} className="focusable-secondary col-lg-6 pr-lg-5 pb-lg-4 mb-4">
                      <img role={"presentation"} alt="icono eventos virtuales" src="img/bibliotecas-que-es/eventos_virtuales.png" />
                      <p className="mb-0 py-3" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.acompanamiento?.eventos }}></p>
                    </li>
                    <li tabIndex={0} className="focusable-secondary col-lg-6 pr-lg-5">
                      <img role={"presentation"} alt="imagen de los boletines" src="img/bibliotecas-que-es/boletines_15_dias.png" />
                      <p className="mb-0 py-3 que-es-parrafo-menor" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.acompanamiento?.boletines }}></p>
                    </li>
                    <li tabIndex={0} className="focusable-secondary col-lg-6 pt-lg-3">
                      <img role={"presentation"} alt="icono del blog" src="img/bibliotecas-que-es/blog_ico.png" />
                      <p className="mb-0 py-3"><strong>{textosBibliotecas?.acompanamiento?.blog || 'Blog especializado '}</strong></p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div tabIndex={0} role={"region"} aria-label={textosBibliotecas?.nuestro_plan?.parte_uno || 'Conoce nuestro plan'} className="focusable-primary club-makemake-section highlight-container demo--instruction-3 py-4 ">
              <div className="row mx-0 py-3">
                <div className="col-lg-8 mx-auto">
                  <div className="align-items-center justify-content-between flex-column">
                    <div className="mx-auto mb-3">
                      <p className="description text-center font-weight-bold"> {textosBibliotecas?.nuestro_plan?.parte_uno || 'Conoce nuestro plan'}</p>
                      <p className="description text-center font-weight-bold">{textosBibliotecas?.nuestro_plan?.parte_dos || 'de acompañamiento especializado'}</p>

                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                      <Link to="/club-makemake" className="focusable-primary d-inline-flex learn-more-button btn btn-primary py-2 px-4 d-block mx-auto">
                        {textosBibliotecas?.botones?.descubrelo || 'Descúbrelo'}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="col-lg-10 mx-auto">
                <p tabIndex={0} className="focusable-secondary important-information  py-4 font-weight-bold">{textosBibliotecas?.caracteristicas?.titulo || 'Características clave'}</p>
                <img className="img-fluid" alt="imagen caracteristicas claves" src="img/bibliotecas-que-es/computador_caracteristicas_clave.png" />

                <div className="row mx-0 py-3 py-lg-5">
                  <ul className="onbackground-primary--color col-lg-6 px-0 px-lg-4">
                    <li tabIndex={0} className="focusable-secondary py-3 text-lg-right linea-roja" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.caracteristicas?.panel }}></li>
                    <li tabIndex={0} className="focusable-secondary py-3 text-lg-right linea-roja" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.caracteristicas?.multidispositivo }}></li>
                    <li tabIndex={0} className="focusable-secondary py-3 text-lg-right linea-roja linea-invisible" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.caracteristicas?.apps }}></li>
                  </ul>
                  <ul className="onbackground-primary--color  col-lg-6 px-0 px-lg-4">
                    <li tabIndex={0} className="focusable-secondary py-3 linea-roja" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.caracteristicas?.autenticacion }}></li>
                    <li tabIndex={0} className="focusable-secondary py-3" dangerouslySetInnerHTML={{ __html: textosBibliotecas?.caracteristicas?.registros }}></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="seccion-azul-gris">
              <div className="container px-lg-0">
                <div className="col-lg-10 mx-auto">
                  <p tabIndex={0} className="focusable-secondary important-information font-weight-bold py-5">{textosBibliotecas?.experiencia?.titulo || 'Experiencia comprobada'}</p>
                  <p className="onbackground-primary--color">{textosBibliotecas?.experiencia?.descripcion || 'descripcion'}</p>

                  <Swiper
                    autoplay={{
                      delay: 3000,
                    }}
                    breakpoints={{
                      526: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                      },
                      992: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                      },
                      1400: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                      }
                    }}
                    className="py-lg-3 mb-4 swiper-editoriales"
                    loop={true}
                    modules={[Autoplay, Keyboard]}
                    pagination={{
                      clickable: true,
                      type: "bullets",
                    }}
                    preloadImages={true}
                    slidesPerView={1}
                  >
                    {crearSlide()}
                  </Swiper>

                  <p className="subtitulo-rojos text-uppercase pb-4">{textosBibliotecas?.experiencia?.subtitulo || '¡Las mejores bibliotecas ya están con makemake!'}</p>

                  <Swiper
                    className="pt-lg-3  pb-lg-4 swiper-editoriales"
                    autoplay={{
                      delay: 5000,
                    }}
                    breakpoints={{
                      526: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                      },
                      992: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                      },
                      1400: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                      }
                    }}
                    loop={true}
                    pagination={{
                      clickable: true,
                      type: "bullets",
                    }}
                    preloadImages={true}
                    slidesPerView={1}
                  >
                    {crearSlideBibliotecas()}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
          <PodemosAyudar />
        </>
      }

    </>
  )
}
export default QueEsBibliotecas;